<template>
	<cleave
		class="fts-form-control"
		:class="{'form-control--error': error}"
		v-model="model"
		:options="options"
		@blur="onBlur"
	/>
</template>

<script>
import Vue from 'vue'
import Cleave from "vue-cleave-component";
Vue.use(Cleave);

import commons from '../commons/commons';

export default {
	props: {
		item: Object,
		formData: Object,
		value: Number,
		numeralIntegerScale: {
			type: Number,
			default: 12,
		},
		numeralDecimalScale: Number,
		numeralPositiveOnly: Boolean,
		error: Boolean
	},
	model: {
    prop: "value",
    event: "updateValue",
  },
	components: {
		Cleave,
	},
	data: () => ({
		rawValue: null,
	}),
	methods: {
		onBlur(evt) {
			this.$emit('blur', evt);
			this.rawValue = null;
		}
	},
	computed: {
		model: {
			get() {
				if (this.rawValue) {
					return this.rawValue
				} else if (this.item && this.item.fieldName) {
					return this.formData[this.item.fieldName];
				} else {
					return this.value;
				}
			},
			set(val) {
				let previousValue = null;

				if (this.item && this.item.fieldName) {
					previousValue = this.formData[this.item.fieldName];
				} else {
					previousValue = this.value;
				}

				const res = commons.isPossibleNumber(val) ? parseFloat(val) : null;

				if (val && val.toString().startsWith('-') && res === 0) {
					this.rawValue = val;
				} else {
					this.rawValue = null;
				}

				if (previousValue === res) return;

				if (this.item && this.item.fieldName) {
					/* item.fieldName */
					this.$set(this.formData, this.item.fieldName, res);
				} else {
					/* value */
					this.$emit('updateValue', res);
				}
				this.$emit('input', res);
			}
		},
		options() {
			const numeralDecimalScale = commons.isInteger(this.numeralDecimalScale) ? 
				this.numeralDecimalScale : this.item && this.item.decimalPlaces;	
			const options = {
				numeral: true,
				numeralIntegerScale: this.numeralIntegerScale,
				numeralPositiveOnly: this.numeralPositiveOnly,
			}
			if (this.item && this.item.type === 4) {
				return options;
			} else {
				return {
					...options,
					numeralDecimalScale: commons.isInteger(numeralDecimalScale) ? numeralDecimalScale : undefined
				}
			}
		},
	},
}
</script>